// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"578":"3ec0b1d9","832":"a543d480"}[chunkId] + ".chunk.css";
};